// extracted by mini-css-extract-plugin
export var footer = "_ni-5";
export var fulfillmentInput = "_ni-0";
export var shipDateInput = "_ni-1";
export var shipmentModal = "_ni-2";
export var shipmentModalContent = "_ni-3";
export var tableContainer = "_ni-4";